var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4461 23.1663H12.1128C9.61279 23.1663 9.61279 21.7797 9.61279 20.6663V19.9997C9.61279 19.3597 10.1395 18.833 10.7795 18.833H22.7795C23.4195 18.833 23.9461 19.3597 23.9461 19.9997V20.6663C23.9461 21.7797 23.9461 23.1663 21.4461 23.1663ZM10.7795 19.833C10.6861 19.833 10.6128 19.9063 10.6128 19.9997V20.6663C10.6128 21.7597 10.6128 22.1663 12.1128 22.1663H21.4461C22.9461 22.1663 22.9461 21.7597 22.9461 20.6663V19.9997C22.9461 19.9063 22.8728 19.833 22.7795 19.833H10.7795Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6127 19.833H10.9793C10.706 19.833 10.4793 19.6063 10.4793 19.333V16.6663C10.4793 13.933 12.4193 11.533 15.086 10.9663C15.4793 10.8797 15.8927 10.833 16.3127 10.833H17.2793C17.706 10.833 18.1193 10.8797 18.5127 10.9663C21.1793 11.5397 23.1127 13.9397 23.1127 16.6663V19.333C23.1127 19.6063 22.8927 19.833 22.6127 19.833ZM11.4793 18.833H22.1127V16.6663C22.1127 14.4063 20.5127 12.4197 18.2993 11.9397C17.9727 11.8663 17.6327 11.833 17.2793 11.833H16.3127C15.966 11.833 15.626 11.8663 15.2993 11.9397C13.086 12.413 11.4793 14.3997 11.4793 16.6663V18.833Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.193 11.953C14.973 11.953 14.773 11.8063 14.713 11.5863C14.6596 11.393 14.633 11.1997 14.633 10.9997C14.633 9.80634 15.6063 8.83301 16.7996 8.83301C17.993 8.83301 18.9663 9.80634 18.9663 10.9997C18.9663 11.1997 18.9396 11.393 18.8863 11.5863C18.8196 11.8397 18.566 11.9997 18.2993 11.9397C17.9727 11.8663 17.6327 11.833 17.2793 11.833H16.3127C15.966 11.833 15.626 11.8663 15.2993 11.9397C15.266 11.9463 15.233 11.953 15.193 11.953ZM16.3127 10.833H17.2793C17.506 10.833 17.7396 10.8463 17.9596 10.873C17.8996 10.2863 17.3996 9.83301 16.7996 9.83301C16.1996 9.83301 15.7063 10.2863 15.6396 10.873C15.8663 10.8463 16.086 10.833 16.3127 10.833Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsMeals);
export default __webpack_public_path__ + "static/media/statistics-meals.68c81fbc4b0cdc0d57b3bb59739a9ac7.svg";
export { ForwardRef as ReactComponent };